module.exports = __webpack_public_path__ + "img/zep3.a6b181d4.png";